import { FC, HTMLAttributes } from 'react';
import { Color, Colors, ColorsDictionary } from '../../types/ui';

const AlertColors: Readonly<ColorsDictionary> = {
    [Colors.Primary]: 'bg-blue-100 text-blue-900 border-blue-200',
    [Colors.Secondary]: 'bg-gray-100 text-gray-900 border-gray-200',
    [Colors.Warning]: 'bg-yellow-100 text-yellow-900 border-yellow-200',
    [Colors.Danger]: 'bg-red-100 text-red-900 border-red-200',
    [Colors.Success]: 'bg-green-100 text-green-900 border-green-200',
    [Colors.Dark]: 'bg-gray-300 text-gray-900 border-gray-400',
    [Colors.Info]: 'bg-purple-100 text-purple-900 border-purple-200',
};

type AlertProps = Omit<HTMLAttributes<HTMLDivElement>, 'color'> & {
    color: Color;
};

const Alert: FC<AlertProps> = ({ children, color }: AlertProps) => {
    return (
        <div
            className={`py-3 px-5 mb-4 text-sm rounded-md border ${AlertColors[color]}`} 
            role="alert"
        >
            {children}
        </div>
    );
};

export default Alert;